import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-menu',
  template: `
  <div class='main-menu-wrapper'>
  <div class='main-menu'>
      <a href='https://www.bhsf.co.uk/' target='_blank'>
        <div class='main-menu__icon'><img src='assets/img/menu/bhsf.svg' alt="BHSF"></div>
        <span class='main-menu__title'>BHSF</span>
      </a>
        <a href='https://selfserve.cpfoods.co.uk/Login.aspx' target='_blank'>
          <div class='main-menu__icon'><img src='assets/img/menu/carval.svg' alt='Carval'></div>
          <span class='main-menu__title'>Carval</span>
        </a>
        <a href='https://app.expensein.com/saml' target='_blank'>
          <div class='main-menu__icon'><img src='assets/img/menu/expensein.svg' alt='ExpenseIn'></div>
          <span class='main-menu__title'>ExpenseIn</span>
        </a>
        <a href='https://www.groceryaid.org.uk/' target='_blank'>
          <div class='main-menu__icon'><img src='assets/img/menu/grocery-aid.png' alt='Website'></div>
          <span class='main-menu__title'>Grocery Aid</span>
        </a>
        <a href='https://www.healthshield.co.uk/' target='_blank'>
          <div class='main-menu__icon'><img src='assets/img/menu/healthshield.svg' alt="Health Shield"></div>
          <span class='main-menu__title'>Health Shield</span>
        </a>
        <a href='https://login.mimecast.com/u/login/?gta=apps#/login' target='_blank'>
          <div class='main-menu__icon'><img src='assets/img/menu/mimecast.svg' alt='Mimecast'></div>
          <span class='main-menu__title'>Mimecast</span>
        </a>
        <a href='https://office.com/' target='_blank'>
          <div class='main-menu__icon'><img src='assets/img/menu/office.svg' alt='Office'></div>
          <span class='main-menu__title'>Office</span>
        </a>
        <a href='https://helpdesk.axonstech.com/' target='_blank'>
          <div class='main-menu__icon'><img src='assets/img/menu/sap-incident.png' alt='SAP Incident Request'></div>
          <span class='main-menu__title'>SAP Incident Request</span>
        </a>
        <a href='https://thefoodfellas.my.salesforce.com/' target='_blank'>
          <div class='main-menu__icon'><img src='assets/img/menu/salesforce.svg' alt='SalesForce'></div>
          <span class='main-menu__title'>SalesForce</span>
        </a>
        <a href='https://thefoodfellas--sandbox.sandbox.my.salesforce.com/' target='_blank'>
          <div class='main-menu__icon'><img src='assets/img/menu/salesforce-1.svg' alt='SalesForce'></div>
          <span class='main-menu__title'>Sandbox</span>
        </a>
        <a href='https://cpfukltd.sharepoint.com/sites/TFFSharepoint' target='_blank'>
          <div class='main-menu__icon'><img src='assets/img/menu/sharepoint.svg' alt='SharePoint'></div>
          <span class='main-menu__title'>SharePoint</span>
        </a>
        <a href='https://app.smartsheet.com/b/home' target='_blank'>
          <div class='main-menu__icon'><img src='assets/img/menu/smartsheet.svg' alt='SmartSheet'></div>
          <span class='main-menu__title'>SmartSheet</span>
        </a>
        <a href='https://www.thepetfellas.co.uk' target='_blank'>
          <div class='main-menu__icon'><img src='assets/img/menu/thepetfellas.svg' alt='ThePetFellas'></div>
          <span class='main-menu__title'>ThePetFellas</span>
        </a>
        <a href='https://the-foodfellas.waybook.com' target='_blank'>
          <div class='main-menu__icon'><img src='assets/img/menu/waybook.svg' alt='Waybook'></div>
          <span class='main-menu__title'>Waybook</span>
        </a>
        <a href='https://outlook.office.com/' target='_blank'>
          <div class='main-menu__icon'><img src='assets/img/menu/webmail.svg' alt='WebMail'></div>
          <span class='main-menu__title'>WebMail</span>
        </a>
        <a href='https://www.thefoodfellas.co.uk' target='_blank'>
          <div class='main-menu__icon'><img src='assets/img/menu/website.svg' alt='Website'></div>
          <span class='main-menu__title'>Website</span>
        </a>
  </div>
  </div>
  `,
  styleUrls: ['./main-menu.component.scss']
})
export class MainMenuComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
